import { Alert, Button, Card, Form, Input, QRCode, Space, Typography } from "antd";
import { useState } from "react";
import { ApiError } from "./api";
import { useSession } from "./session";

/** Giriş: e-posta + parola, ardından TOTP (mağaza yöneticisi ve platform operasyonu için zorunlu). */
export function LoginPage() {
  const step = useSession((s) => s.step);
  const login = useSession((s) => s.login);
  const verifyTotp = useSession((s) => s.verifyTotp);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function run(action: () => Promise<void>) {
    setBusy(true);
    setError(null);
    try {
      await action();
    } catch (e) {
      // Hangi bilginin yanlış olduğu söylenmez (hesap varlığı sızmasın).
      setError(e instanceof ApiError && e.status === 401
        ? "Bilgiler doğrulanamadı. Lütfen kontrol edip tekrar deneyin."
        : "Giriş şu an yapılamıyor; lütfen tekrar deneyin.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card style={{ maxWidth: 420, margin: "48px auto" }} title="SalesOS Console'a giriş">
      {error && <Alert type="error" title={error} style={{ marginBottom: 16 }} showIcon />}
      {step.kind === "password" && (
        <Form layout="vertical" onFinish={(v: { email: string; password: string }) => run(() => login(v.email, v.password))}>
          <Form.Item label="E-posta" name="email" rules={[{ required: true, type: "email", message: "E-posta girin" }]}>
            <Input autoComplete="username" autoFocus />
          </Form.Item>
          <Form.Item label="Parola" name="password" rules={[{ required: true, message: "Parola girin" }]}>
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={busy} block>Devam</Button>
        </Form>
      )}
      {step.kind !== "password" && (
        <Space orientation="vertical" style={{ width: "100%" }}>
          {step.kind === "enroll" ? (
            <>
              <Typography.Paragraph>
                Hesabınız için iki adımlı doğrulama kurun. Doğrulama uygulamanızla (ör. Google Authenticator) kodu
                okutun veya anahtarı elle girin, ardından uygulamanın gösterdiği 6 haneli kodu yazın.
              </Typography.Paragraph>
              <QRCode value={step.otpauthUri} aria-label="Doğrulama uygulaması için QR kod" />
              <Typography.Text>
                Anahtar: <Typography.Text code copyable>{step.secret}</Typography.Text>
              </Typography.Text>
            </>
          ) : (
            <Typography.Paragraph>Doğrulama uygulamanızdaki 6 haneli kodu girin.</Typography.Paragraph>
          )}
          <Form layout="vertical" onFinish={(v: { code: string }) => run(() => verifyTotp(v.code))}>
            <Form.Item label="Doğrulama kodu" name="code"
              rules={[{ required: true, pattern: /^\d{6}$/, message: "6 haneli kodu girin" }]}>
              <Input inputMode="numeric" autoComplete="one-time-code" maxLength={6} autoFocus />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={busy} block>Doğrula</Button>
          </Form>
        </Space>
      )}
    </Card>
  );
}
